module.exports = __webpack_public_path__ + "static/media/Kishan_Resume.00198e3e.pdf";